import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loader/forms.svg'
import _imports_1 from '@/assets/loader/fragment-1.svg'
import _imports_2 from '@/assets/loader/indicador-1.svg'


const _withScopeId = n => (_pushScopeId("data-v-6e56fcd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fragment__background" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "fragment__background-image",
    src: _imports_0
  })
], -1))
const _hoisted_2 = { class: "fragment__container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fragment__container-main-image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fragment__container-indicador-image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_5 = { class: "fragment__container-data" }
const _hoisted_6 = { class: "container-data" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-data__title" }, "Remember know yourself is important", -1))
const _hoisted_8 = { class: "container-data__button" }
const _hoisted_9 = { class: "container-data__message" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Already have an account?")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fragment", {'hide-left':_ctx.hideLeft, 'entry-left': _ctx.entryLeft }]),
    onTouchstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.touchStart && _ctx.touchStart(...args))),
    onTouchend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.touchEnd && _ctx.touchEnd(...args)))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goLogin && _ctx.goLogin(...args)))
            }, "Sign Up")
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goLogin && _ctx.goLogin(...args)))
            }, "Login")
          ])
        ])
      ])
    ])
  ], 34))
}